import type { AiReplyState } from '../../../../monitoring/messages/triage/aiTriageState';

export type AiDraftState = Extract<AiReplyState, { kind: 'draft' }>;

// Changes only when what the thread shows changes, not on every clock tick.
export function aiReplyStateKey(state: AiReplyState): string {
    return state.kind === 'draft' ? `draft:${state.reply}` : state.kind;
}
